/**
 * FF AI Agent /agent route layout — 三栏壳
 *
 * 左：会话列表 | 中：对话区（page.tsx 注入）| 右：上下文面板
 *
 * 三栏在 page.tsx 里组装，本 layout 只负责全屏底色 + 字体 + i18n 切换钩子
 * 不依赖 workspace 主导航 sidebar（agent 是独立 full-screen 工作面）。
 *
 * 详见 docs/modules/agent/01-prd-phase1.md PR1 DoD。
 */

import type { ReactNode } from 'react';

export default function AgentLayout({ children }: { children: ReactNode }) {
  return (
    <div className="h-screen w-screen overflow-hidden bg-stone-50 text-neutral-900 antialiased dark:bg-neutral-950 dark:text-neutral-100">
      {children}
    </div>
  );
}
